"use strict";

(function () {
  'use strict';

  function ProfileCtrl($window, $state, AccountService, AuthService, PaymentService, LRNotification) {
    var vm = this;
    var guestState;
    var billingState;
    this.loading = true;
    this.initial = true;
    this.year = '';
    this.month = '';
    this.day = '';
    this.lastKnownDateOfBirth = null;

    this.updateProfile = function (type, profileObject) {
      this.loading = type;

      var _profile = angular.copy(profileObject);

      AccountService.updateProfile(_profile).then(function (response) {
        LRNotification.success('Profile Updated Successfully', 3500);

        if (response && response.dateOfBirth) {
          vm.fixDateOfBirth(response.dateOfBirth);
        }

        vm.loading = false;
      }, function (error) {
        console.log(error);
        vm.loading = false;
      });
    };

    this.updateUserInfo = function (e) {
      if (!vm.year) {
        return alert('Please select a year.');
      }

      if (!vm.month) {
        return alert('Please select a month.');
      }

      if (!vm.day) {
        return alert('Please select a day.');
      }

      vm.editUserInfo = false;
      vm.updateProfile('user', this.profile);
    };

    this.getStates = function (type) {
      var defaultState = {
        ZZ: '--'
      };
      var _types = {
        guest: 'country',
        billing: 'billingCountry'
      };

      if (vm.profile && vm.states && vm.states.hasOwnProperty(vm.profile[_types[type]])) {
        vm.selectStates[type] = vm.states[vm.profile[_types[type]]];
      } else {
        vm.selectStates[type] = defaultState;
      } // set state model for select


      if (type === 'guest') {
        if (vm.selectStates[type].hasOwnProperty(guestState)) {
          vm.profile.state = guestState;
        } else {
          vm.profile.state = 'ZZ';
        }
      } else if (type === 'billing') {
        if (vm.selectStates[type].hasOwnProperty(billingState)) {
          vm.profile.billingState = billingState;
        } else {
          vm.profile.billingState = 'ZZ';
        }
      }
    };

    this.hasStates = function (type) {
      return vm.selectStates[type].length && !vm.selectStates[type][0].hasOwnProperty('ZZ');
    };

    this.days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
    this.months = [{
      id: 1,
      name: 'January'
    }, {
      id: 2,
      name: 'February'
    }, {
      id: 3,
      name: 'March'
    }, {
      id: 4,
      name: 'April'
    }, {
      id: 5,
      name: 'May'
    }, {
      id: 6,
      name: 'June'
    }, {
      id: 7,
      name: 'July'
    }, {
      id: 8,
      name: 'August'
    }, {
      id: 9,
      name: 'September'
    }, {
      id: 10,
      name: 'October'
    }, {
      id: 11,
      name: 'November'
    }, {
      id: 12,
      name: 'December'
    }];
    this.years = [];
    var d = new Date();

    for (var i = d.getFullYear() - 18; i > d.getFullYear() - 120; i--) {
      vm.years.push(i);
    }

    this.updateDate = function (input) {
      if (input == 'year') {// vm.month = '';
        // vm.day = '';
      } else if (input == 'month') {// vm.day = '';
      }

      if (vm.year && vm.month && vm.day) {
        vm.profile.dateOfBirth = new Date(vm.year, vm.month.id - 1, vm.day).toISOString();
      }
    };

    this.fixDateOfBirth = function (strDate) {
      var birthday = new Date(strDate);
      vm.year = vm.years.find(function (y) {
        return y === birthday.getFullYear();
      });
      vm.month = vm.months.find(function (m) {
        return m.id === birthday.getMonth() + 1;
      });
      vm.day = vm.days.find(function (d) {
        return d === birthday.getDate();
      });
      vm.lastKnownDateOfBirth = {
        year: vm.year,
        month: vm.month,
        day: vm.day
      };
    };

    this.resetDateOfBirth = function () {
      if (vm.lastKnownDateOfBirth) {
        var _vm$lastKnownDateOfBi = vm.lastKnownDateOfBirth,
            day = _vm$lastKnownDateOfBi.day,
            month = _vm$lastKnownDateOfBi.month,
            year = _vm$lastKnownDateOfBi.year;
        vm.year = year;
        vm.month = month;
        vm.day = day;
      }

      vm.updateDate();
    };

    this.autofillDesc = 'These addresses are used to Autofill future trip reservations when signed in to LiveStay during the checkout process.';

    this.$onInit = function () {
      this.profile = {};
      this.user = AuthService.getUser();
      this.selectStates = {
        guest: [],
        billing: []
      };
      AccountService.getProfile().then(function (response) {
        //console.log(response);
        vm.profile = response;
        vm.loading = false;
        vm.initial = false;

        if (vm.profile.dateOfBirth) {
          vm.fixDateOfBirth(vm.profile.dateOfBirth);
        }

        guestState = vm.profile.state;
        billingState = vm.profile.billingState;
        PaymentService.getCountries().then(function (data) {
          vm.countries = data;
        });
        PaymentService.getStates().then(function (data) {
          vm.states = data;
          vm.getStates('guest');
          vm.getStates('billing');
        });
      }, function (error) {
        //console.log(error);
        vm.loading = false;
        vm.initial = false;
        PaymentService.getCountries().then(function (data) {
          vm.countries = data;
        });
        PaymentService.getStates().then(function (data) {
          vm.states = data;
          vm.getStates('guest');
          vm.getStates('billing');
        });
      });
    };
  }

  ProfileCtrl.$inject = ['$window', '$state', 'AccountService', 'AuthService', 'PaymentService', 'LRNotification'];
  angular.module('view.account').component('profile', {
    bindings: {},
    controller: ProfileCtrl,
    templateUrl: 'views/account/components/profile/profile.html'
  });
})();